/*eslint no-script-url: 0 */
import React, { Component } from "react";
import Constants from '../Config/Config';
import {Loader} from '../Helpers/Helpers';
import Parser from 'html-react-parser';

const URL = Constants.URL.root+'/wp-content/themes/justpictureframing/data/printing.json';

class Printing extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      error: null
    }
    this.selectPrint = this.selectPrint.bind(this);
  }

  selectPrint (e) {
    this.dispatchSelectPrint(e.currentTarget.value);
  }

  fetchPrinting = () => {
    var self = this;
    fetch(URL)
    .then(response => {
      if (!response.ok) {
        throw Error('Network request failed.')
      }
      return response;
    })
    .then(data => data.json())
    .then(data => {
      //console.log(data);
      self.dispatchPrintData(data);
      if ( self.props.selectedPrint === null ) {
        data.filter( ( print ) =>
          'Yes' === print['acf']['default_selected_printing']
        ).map( ( print ) =>
          self.dispatchSelectPrint(print.id)
        )
      }
      self.setState({ isLoaded: true });
    }, (ex) => {
      self.setState({ error: ex.message });
    })
  }

  dispatchPrintData(PrintData) {
    const data = PrintData;
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        printing: data
      }
    })
  }

  dispatchSelectPrint(Print) {
    const sData = Print;
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        selectedPrint: sData
      }
    })
  }

  componentDidMount() {
    this.fetchPrinting();
  }

  render() {
    const { isLoaded, error } = this.state;
    if (error) {
      return <div className="alert alert-danger">{error}</div>;
    } else if (!isLoaded) {
      return <div className="loadingSec"><Loader/></div>;
    } else {
      return (
        <div className="row">
          <div className="col-sm-4">
            {this.props.printing.map( (print) =>
              <div className="print-items" key={print.get('id')}>
                <div className="card h-100">
                  <div className="card-body">
                  	<div className="row">
	                    <div className="col-sm-12">
	                      <h4 className="card-title">
	                      	<label className="checkcontainer">
	                      		<input type="radio" name="print" value={print.get('id')} onChange={this.selectPrint} checked={parseFloat(this.props.selectedPrint) === print.get('id') ? true : false } /> {print.getIn(['title', 'rendered'])}
                            <span className="radiobtn"></span>
	                      	</label>
	                      </h4>
	                    </div>
	                  </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <PrintingContent
            {...this.props}
            selectedPrint={this.props.selectedPrint}
            printing={this.props.printing} />
        </div>
      );
    }
  }
}

export default Printing;

class PrintingContent extends Component {
  render() {
    const { printing, selectedPrint } = this.props;
    if( selectedPrint === null ) {
      return (
        <div className="col-sm-8 print-items"></div>
      );
    }
    return (
      <div className="col-sm-8 print-items">
        {printing.filter( ( print ) =>
          parseFloat(selectedPrint) === print.get('id')
        ).map( ( print ) =>
          <div key={print.get('id')}>
            <div className="price-tab">
              {Constants.Currency + this.props.printTotal}
            </div>
            {Parser(print.getIn(['content', 'rendered']))}
          </div>
        )}
      </div>
    );
  }
}